import React from "react";

const ImagePreviewModal = ({ imagePreview, onClose }) => {
  const handleBackgroundClick = (e) => {
    // Prevent click inside image or close button from closing the modal
    if (e.target.id === "modal-overlay") {
      onClose();
    }
  };

  return (
    <div
      id="modal-overlay"
      onClick={handleBackgroundClick}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: 20,
          right: 30,
          background: "transparent",
          border: "none",
          fontSize: "2rem",
          color: "#fff",
          cursor: "pointer",
        }}
        aria-label="Close"
      >
        &times;
      </button>

      {/* Image */}
      <img
        src={imagePreview}
        alt="Full Preview"
        style={{
          maxWidth: "90%",
          maxHeight: "90%",
          borderRadius: 8,
          boxShadow: "0 0 20px rgba(0,0,0,0.5)",
          zIndex: 10000,
        }}
      />
    </div>
  );
};

export default ImagePreviewModal;
